import React from 'react';
import { styled } from '@linaria/react';
import { formatDistanceToNowStrict } from 'date-fns';
import { Review } from 'modules/trustPilot/trustPilot.types';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { NoStyleLink } from '@daedalus/atlas/helpers/NoStyleLink';
import { Text } from '@daedalus/atlas/Text';
const _exp = /*#__PURE__*/() => Flex.Column;
const ReviewCard = /*#__PURE__*/styled(_exp())({
  name: "ReviewCard",
  class: "r13auwq5",
  propsAsIs: true
});
const _exp7 = /*#__PURE__*/() => Text;
const ReviewText = /*#__PURE__*/styled(_exp7())({
  name: "ReviewText",
  class: "r5k6aud",
  propsAsIs: true
});
const ReviewRate = /*#__PURE__*/styled('img')({
  name: "ReviewRate",
  class: "r1ceqfk3",
  propsAsIs: false
});
const _exp11 = /*#__PURE__*/() => Flex.Column;
const ConsumerWrapper = /*#__PURE__*/styled(_exp11())({
  name: "ConsumerWrapper",
  class: "cd41yr5",
  propsAsIs: true
});
const QuotationMarkWrapper = /*#__PURE__*/styled('div')({
  name: "QuotationMarkWrapper",
  class: "q1w9s7tp",
  propsAsIs: false
});
const QuotationMarkSvg = /*#__PURE__*/styled('svg')({
  name: "QuotationMarkSvg",
  class: "qwnd26z",
  propsAsIs: false
});
const QuotationMark = () => <QuotationMarkSvg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.328 10.04C15.328 11.624 13.984 12.92 12.208 12.92C10.336 12.92 8.704 11.576 8.704 8.84C8.704 3.176 12.4 0.727998 15.088 0.439999V2.696C12.976 3.176 11.536 5.384 11.488 7.352C11.632 7.256 11.968 7.112 12.448 7.112C14.032 7.112 15.328 8.216 15.328 10.04ZM7.12 10.04C7.12 11.624 5.776 12.92 4 12.92C2.128 12.92 0.496 11.576 0.496 8.84C0.496 3.176 4.192 0.727998 6.88 0.439999V2.696C4.768 3.176 3.328 5.384 3.28 7.352C3.424 7.256 3.76 7.112 4.24 7.112C5.824 7.112 7.12 8.216 7.12 10.04Z" />
  </QuotationMarkSvg>;
interface Props {
  review: Review;
}
export const TrustPilotReview: React.FC<Props> = ({
  review
}) => {
  const {
    isMobile
  } = useDeviceLayout();
  return <NoStyleLink href="https://www.trustpilot.com/review/vio.com" target="_blank">
      <ReviewCard justifyContent="space-between" alignItems="flex-start">
        <QuotationMarkWrapper>
          <QuotationMark />
        </QuotationMarkWrapper>
        <ReviewText variant={isMobile ? 'bodyM' : 'titleL'}>
          {review.text}
        </ReviewText>
        <ConsumerWrapper gap="s300">
          <ReviewRate src={`https://images-static.trustpilot.com/api/stars/${review.stars}/star.svg`} alt="review-rate" />
          <Text variant={isMobile ? 'bodyS' : 'bodyM'} colorPath="content.neutral.c800">
            {review.consumer.displayName} ,{' '}
            {formatDistanceToNowStrict(new Date(review.createdAt), {
            addSuffix: true
          })}
          </Text>
        </ConsumerWrapper>
      </ReviewCard>
    </NoStyleLink>;
};

require("./TrustPilotReview.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./TrustPilotReview.tsx");